module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkgNEg2VjFhMSAxIDAgMCAwLTIgMHYzSDFhMSAxIDAgMCAwIDAgMmgzdjNhMSAxIDAgMCAwIDIgMFY2aDNhMSAxIDAgMCAwIDAtMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/secondary-menu-expand-plus-black.svg
// module id = hwsA
// module chunks = 1